define('widgets/dgrid/blocks/allGames/allGames',[
    'knockout',
    'underscore'
], function(ko, _) {

    var AllGamesBlock = function(getFields) {
        var self = this;

        self.headline = getFields('headline');
        self.buttonText = getFields('cta_text');
        self.backgroundColor = getFields('background_color');
        self.backgroundImage = getFields('background_image');
    };

    AllGamesBlock.prototype.activate = function(settings) {
        var self = this;

        self.activateFallback = settings.activateFallback;

    };

    return AllGamesBlock;
});

